<template>
  <section>
    <div class="has-text-weight-semibold header-label spacing-my-20">
      <div>
        <span>{{ `${General.PROCEDURES}: ` }}</span>
        <span class="is-size-5">{{ `${timelineItems.length} ` }} </span>
      </div>
      <span
        v-if="!isMobile"
        class="is-size-5 has-text-weight-semibold mx-5 has-text-grey-lighter"
        >|</span
      >
      <span>
        {{ General.TOTAL_PROCESS_TIME }}
        {{ milisecondsToFormatedTime(processTime) }}</span
      >
    </div>
    <section>
      <b-loading
        data-cy="LOADING_HISTORY"
        :isFullPage="false"
        :active="isLoadingHistory"
      />
      <TimelineItem
        v-for="(item, index) in timelineItems"
        :key="index"
        :class="{ 'spacing-ml-10': !isMobile }"
        statusColor="green-light"
        :dateTitle="new Date(item.date)"
        :remainTime="
          item.permanency &&
            milisecondsToFormatedTime(new Date(item.permanency).getTime())
        "
        :hideProgressLine="index === timelineItems.length - 1"
      >
        <div class="timeline-content is-size-6 has-text-weight-normal">
          <p>
            <span class="has-text-weight-semibold">{{ General.STATUS }}</span
            >: {{ item.status }}
          </p>
          <p>
            <span class="has-text-weight-semibold">{{
              General.ORGAN_UNIT
            }}</span
            >: {{ getCapacityFormatted(item.capacity) }}
            <span v-if="item.external_system_abbreviation">
              | {{ General.PROCESS_REGISTERED }}
              {{ item.external_system_abbreviation }}
            </span>
          </p>

          <b-button
            v-if="item.status == `Processo apensado`"
            class="button-appender"
            type="is-text"
            iconLeft="magnify-plus"
            outlined
            role="button"
            @click="goToAppender"
          >
            {{ General.TEXTS.VIEW_APPENDED_PROCESS.toUpperCase() }}</b-button
          >
        </div>
      </TimelineItem>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { App, General } from "@/utils/constants";

import TimelineItem from "@/components/TimelineItem";

import { milisecondsToFormatedTime } from "@/utils/timeUtility";
import { PROCESS_DETAILS_TABS as TABS } from "@/utils/enumerate";

export default {
  name: "TimelineTab",
  components: {
    TimelineItem
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      App,
      General,
      TABS,
      milisecondsToFormatedTime,
      isLoadingHistory: true
    };
  },

  computed: {
    ...mapGetters({
      timelineItems: "getTimeLineItens",
      processTime: "getProcessTime",
      getCurrentTab: "getCurrentTabProcessDetails",
      getCapacityFormatted: "getCapacityFormatted",
      isMobile: "isMobile"
    }),

    activeTab() {
      return this.getCurrentTab.value;
    }
  },

  watch: {
    activeTab: {
      handler(actualTab) {
        if (actualTab === this.TABS.TIMELINE.value) {
          this.isLoadingHistory = true;
          this.timeLineItensRequest(this.id).finally(() => {
            this.checkProcess(this.id);
            this.isLoadingHistory = false;
          });
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      timeLineItensRequest: "timeLineItensRequest",
      checkProcess: "checkProcessHistoryInternal"
    }),

    goToAppender() {
      this.$router.push(
        `/app/processos/detalhamento/${this.process.process_join.id}`
      );
      this.$router.go();
      this.setCurrentTab(this.TABS.BASIC_DATA.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.button-appender {
  color: $primary;
  text-decoration: none;
  font-weight: bold;
  padding: 0;
  padding-left: 5px;
  align-items: flex-start;
}

.button-appender:hover {
  color: $primary;
  opacity: 0.5;
  background-color: transparent;
}

.header-label {
  display: flex;
  align-items: center;
  @media screen and (max-width: $tablet) {
    flex-direction: column;
    align-items: flex-start;
  }
  background-color: $background-color;
  border-radius: 15px;
  padding: 5px 15px;
}

.timeline-content {
  @media screen and (max-width: $tablet) {
    padding-left: 10px;
  }
}
</style>
